import { remark } from 'remark';
import html from 'remark-html';
import blogPostsData from '../data/blogPosts.json';

export interface BlogPost {
  id: string;
  title: string;
  date: string;
  author: string;
  category: string;
  tags: string[];
  excerpt: string;
  content: string;
  htmlContent?: string;
}

export async function getAllPosts(): Promise<BlogPost[]> {
  try {
    console.log('Getting all posts...');
    console.log('Available posts:', blogPostsData.posts);
    
    const allPostsData = await Promise.all(
      blogPostsData.posts.map(async (post) => {
        try {
          console.log('Processing post:', post.id);
          // Process the markdown content
          const processedContent = await remark()
            .use(html)
            .process(post.content);
          const contentHtml = processedContent.toString();
          
          console.log('Processed HTML content:', contentHtml);
          
          // Create the blog post object
          const blogPost: BlogPost = {
            ...post,
            htmlContent: contentHtml
          };
          
          console.log('Created blog post object:', blogPost);
          return blogPost;
        } catch (error) {
          console.error(`Error processing post ${post.id}:`, error);
          return null;
        }
      })
    );

    // Filter out any null values and sort by date
    const validPosts = allPostsData.filter((post): post is BlogPost => post !== null);
    return validPosts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  } catch (error) {
    console.error('Error in getAllPosts:', error);
    return [];
  }
}

export async function getPostById(id: string): Promise<BlogPost | undefined> {
  try {
    console.log('Getting post by id:', id);
    console.log('Available posts:', blogPostsData.posts);
    
    const post = blogPostsData.posts.find(p => p.id === id);
    console.log('Found post:', post);
    
    if (!post) {
      console.log('Post not found');
      return undefined;
    }
    
    // Process the markdown content
    console.log('Processing markdown content:', post.content);
    const processedContent = await remark()
      .use(html)
      .process(post.content);
    const contentHtml = processedContent.toString();
    
    console.log('Processed HTML content:', contentHtml);
    
    // Create the blog post object
    const blogPost: BlogPost = {
      ...post,
      htmlContent: contentHtml
    };
    
    console.log('Created blog post object:', blogPost);
    return blogPost;
  } catch (error) {
    console.error('Error in getPostById:', error);
    return undefined;
  }
}

export interface PostId {
  params: {
    id: string;
  };
}

export function getAllPostIds(): PostId[] {
  return blogPostsData.posts.map(post => ({
    params: { id: post.id }
  }));
} 